import React, { Component } from 'react';
import { Player }           from 'video-react';

class VideoSlide extends Component {

    componentDidUpdate(prevProps) {
        if (this.props.isPlay !== prevProps.isPlay) {
            this.play();
        } else {
            this.load();
        }
    }

    play() {
        this.player.play();
    }

    load() {
        this.player.load();
    }

    render() {
        let {
            isCurrentSlide,
            isPlay,
            source: {
                path,
                muted = true,
                poster = ''
            }
        } = this.props;

        return (
            <div className={ `b-slide ${ isCurrentSlide ? 'b-slide--active b-slide--video' : '' }` }>
                <Player
                    ref={ player => {
                        this.player = player;
                    } }
                    muted={ muted }
                    autoPlay={ isPlay }
                    poster={ poster }
                    src={ path }
                    playsInline
                >
                </Player>
            </div>
        );
    }
}

export default VideoSlide;
